<script>
import moment from 'moment'
import { relativeDateOptions } from '../utils/relativeDates'
import ValueComboBox from './ValueComboBox'

export default {
  name: 'RelativeDateComboBox',
  components: {
    ValueComboBox
  },
  props: {
    value: { type: Object, required: false },
    start: { type: Number, required: false },
    end: { type: Number, required: false },
    label: { type: String, required: false, default: 'Date' }
  },
  computed: {
    items() {
      const customValue = {
        value: 'CUSTOM',
        text: this.customDate ? `Custom (${moment(this.customDate).format('LLLL')})` : 'Custom'
      }
      if (this.start && this.end) {
        return [
          ...relativeDateOptions.map(({ value, text, compute }) => ({
            value,
            text: `${text} (${compute(this.start, this.end).format('LLLL')})`
          })),
          customValue
        ]
      } else {
        return [...relativeDateOptions.map(({ value, text }) => ({ value, text })), customValue]
      }
    },
    customDateAsDateString: {
      get() {
        return moment(this.customDate).format('YYYY-MM-DD')
      },
      set(value) {
        if (this.selectedOption === 'CUSTOM') {
          this.customDate = moment(value).unix() * 1000
          this.emitUpdate()
        }
      }
    }
  },
  data() {
    return {
      selectedOption: this.value && this.value.selectedOption,
      customDate: this.value && this.value.customDate,
      menu: false
    }
  },
  inheritAttrs: false,
  methods: {
    onSelectedOptionInput(value) {
      this.selectedOption = value
      if (value === 'CUSTOM') {
        this.customDate = this.customDate || this.start || this.end || Date.now()
        this.menu = true
      } else {
        this.customDate = null
        this.emitUpdate()
      }
    },
    emitUpdate() {
      console.log('Emitting update', {
        selectedOption: this.selectedOption,
        customDate: this.customDate
      })
      this.$emit('input', {
        selectedOption: this.selectedOption,
        customDate: this.customDate
      })
    }
  },
  watch: {
    input: function(oldValue, newValue) {
      this.selectedOption = newValue.selectedOption
      this.customDate = newValue.customDate
    }
  }
}
</script>

<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="true"
    transition="scale-transition"
    offset-y
    min-width="290px"
    v-bind="$attrs"
  >
    <template v-slot:activator="{ on, attrs }">
      <value-combo-box
        :value="selectedOption"
        @input="onSelectedOptionInput"
        :items="items"
        :label="label"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker v-model="customDateAsDateString" no-title scrollable />
    <!-- <v-time-picker v-mdoel="customTime" /> -->
  </v-menu>
</template>
